import { ColGroupDef } from '@ag-grid-enterprise/all-modules';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from 'shared/commonGrid/grid-enums';
import { getFieldFromFirstInterfaceNameValueGetter } from 'utils/valueGetters';
import { TlsProxy, TlsProxyListener, TlsProxyDestination } from 'data/tlsProxy/tlsProxy.types';
import i18n from 'i18n';

export enum TlsProxyMenuActionsType {
  Copy = 'copy',
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const tlsProxyColumnDefs: ColGroupDef[] = [
  {
    headerName: '',
    children: [
      {
        headerName: '',
        field: COMMON_GRID_COLUMN_FIELD_NAMES.Action,
        cellRenderer: 'actionMenuCellRenderer',
      },
      {
        headerName: i18n.t('securityGateway.grid.securityGatewayName'),
        field: 'name',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'name',
        flex: 1,
        minWidth: 259,
      },
      {
        headerName: i18n.t('securityGateway.grid.xcipioNode'),
        field: 'nodeName',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'nodeName',
        flex: 1,
        minWidth: 150,
      },
      {
        headerName: i18n.t('securityGateway.grid.instanceId'),
        field: 'instanceId',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'instanceId',
        flex: 1,
        minWidth: 150,
      },
    ],
  },
  {
    headerName: i18n.t('securityGateway.grid.listener1'),
    children: [
      {
        headerName: i18n.t('securityGateway.grid.ipAddress'),
        field: 'ipAddress',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'ipAddress',
        flex: 1,
        minWidth: 218,
        tooltipValueGetter: getFieldFromFirstInterfaceNameValueGetter<TlsProxy, TlsProxyListener>(
          'listeners',
        ),
        valueGetter: getFieldFromFirstInterfaceNameValueGetter<TlsProxy, TlsProxyListener>('listeners'),
      },
      {
        headerName: i18n.t('securityGateway.grid.port'),
        field: 'port',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'port',
        flex: 1,
        minWidth: 191,
        tooltipValueGetter: getFieldFromFirstInterfaceNameValueGetter<TlsProxy, TlsProxyListener>(
          'listeners',
        ),
        valueGetter: getFieldFromFirstInterfaceNameValueGetter<TlsProxy, TlsProxyListener>('listeners'),
      },
    ],
  },
  {
    headerName: i18n.t('securityGateway.grid.destination1'),
    children: [
      {
        headerName: i18n.t('securityGateway.grid.ipAddress'),
        field: 'ipAddress',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'ipAddress',
        flex: 1,
        minWidth: 218,
        tooltipValueGetter: getFieldFromFirstInterfaceNameValueGetter<TlsProxy, TlsProxyDestination>(
          'destinations',
        ),
        valueGetter: getFieldFromFirstInterfaceNameValueGetter<TlsProxy, TlsProxyDestination>('destinations'),
      },
      {
        headerName: i18n.t('securityGateway.grid.port'),
        field: 'port',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'port',
        flex: 1,
        minWidth: 218,
        tooltipValueGetter: getFieldFromFirstInterfaceNameValueGetter<TlsProxy, TlsProxyDestination>(
          'destinations',
        ),
        valueGetter: getFieldFromFirstInterfaceNameValueGetter<TlsProxy, TlsProxyDestination>('destinations'),
      },
    ],
  },
];
